import React from 'react';
import ReleaseCard from './ReleaseCard';

export default function ReleaseV150({ createClickableListItem, createThumbnail }) {
  return (
    <ReleaseCard version="v1.5.0" date="5th August 2025" title="We've included an easier way for you to get in touch with us!">
      <p className="text-gray-300 mb-4">We adore your comments and suggestions so thought it only right to include a better way for you to get in touch! You can now supply your feedback via the in-game menu button at the bottom right of the screen!</p>
      <ul className="text-gray-400 space-y-2 mb-4">
        {createClickableListItem('Users can now send feedback when in a game', '/v1.5.0/feedback.jpg')}
        <li>• Added map link to clubs to display club location</li>
        <li>• General performance improvements</li>
      </ul>
      <div className="mb-4">
        <p className="text-gray-300 mb-2 text-sm">This releases screenshots:</p>
        <div className="flex flex-wrap gap-4">
          {createThumbnail('/v1.5.0/feedback.jpg', 'Users can now send feedback when in a game feature preview')}
        </div>
      </div>
      <p className="text-purple-400 font-medium">Try out the new features and give us your all-important feedback!</p>
    </ReleaseCard>
  );
}
